import { Card, Container, CardContent, Typography, Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';
import Avatar from 'react-avatar';
import { PROMOTE_DATA } from '../../utils/constants';
import Page from '../../components/Page';
import palette from '../../theme/palette';
import EmailIcon from '../../svg/EmailIcon';
import PhoneIcon from '../../svg/PhoneIcon';
import '../../css/promote.css';
import ShareModal from '../../components/ShareModal';
import { captureGAEvents } from '../../analytics/google.analytics';
import { GAEvents } from '../../analytics/events.constants';

const useStyles = makeStyles({
  cardContainer: {
    background:
      'linear-gradient(140.82deg, rgba(251, 133, 0, 0.06) 0%, rgba(25, 117, 255, 0.06) 102.19%)',
    position: 'relative'
  },
  detailsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 50px'
  },
  nameAndImageContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  nameContainer: {
    marginLeft: 20
  },
  expAndHourContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 30
  },
  activityContainer: {
    flex: 1,
    textAlign: 'center'
  },
  titleText: {
    fontSize: 18,
    marginBottom: 20
  },
  contactContainer: {
    marginTop: 20
  }
});

export default function Promote() {
  const classes = useStyles();
  const [openModal, setModal] = useState(false);
  const currentUser = useSelector((state) => state.auth.currentUser);
  // const { currentUser } = useAuth();

  useEffect(() => {
    captureGAEvents(GAEvents.classesScreen, {
      screen: 'Promote'
    });
  }, []);

  return (
    <Page title="Promote">
      <Container>
        <Card className={classes.cardContainer}>
          <CardContent>
            <div className="ribbon rightRibbon">
              <span />
            </div>
            <div className={`${classes.detailsContainer} detailContainer`}>
              <div className={`${classes.nameAndImageContainer} nameAndImageContainer`}>
                <Avatar name={currentUser?.fullName} size={90} style={{ marginRight: 13 }} round />
                <div className={`${classes.nameContainer} nameContainer`}>
                  <Typography variant="h4">{currentUser?.fullName}</Typography>
                  <Typography>
                    Joined Fainlearn {`${moment(currentUser?.createdAt).format('DD MMM, YYYY')}`}
                  </Typography>
                  {currentUser?.city && <Typography>{currentUser?.city}</Typography>}
                </div>
              </div>
              <div className="emailAndNumber">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <EmailIcon color={palette.secondary.main} />
                  <Typography style={{ marginLeft: 15 }}>{currentUser?.email ?? '-'}</Typography>
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <PhoneIcon color={palette.secondary.main} />
                  <Typography style={{ marginLeft: 15 }}>
                    {currentUser?.mobileNumber ?? '-'}
                  </Typography>
                </div>
              </div>
            </div>
            {/* TODO: here need to apply analytics data */}
            <div className={classes.expAndHourContainer}>
              <div className={classes.activityContainer}>
                <Typography className={classes.titleText}>Experience</Typography>
                <Typography variant="h3">{PROMOTE_DATA.totalExp}</Typography>
                <Typography color={palette.grey[600]}>years</Typography>
              </div>
              <div className={classes.activityContainer}>
                <Typography className={classes.titleText}>Teaching Hour</Typography>
                <Typography variant="h3">{PROMOTE_DATA.teachingHour}</Typography>
                <Typography color={palette.grey[600]}>hours</Typography>
              </div>
            </div>
            {/* TODO: Here need to change the subject names from API */}
            <div style={{ marginTop: 20 }}>
              <Typography style={{ display: 'flex', justifyContent: 'center' }}>
                <Typography variant="h5">Subjects -</Typography>{' '}
                {PROMOTE_DATA.subjects.map((s, i) => (
                  <Typography key={i} variant="h5" style={{ marginLeft: 5 }}>{`${
                    PROMOTE_DATA.subjects.length === i + 1 ? '& ' : ''
                  }${s}${PROMOTE_DATA.subjects.length !== i + 1 ? ', ' : ''}`}</Typography>
                ))}
              </Typography>
            </div>
          </CardContent>
        </Card>
        <div style={{ margin: '20px auto', width: '40%' }}>
          <Button
            variant="contained"
            fullWidth
            style={{ borderRadius: '20px' }}
            onClick={() => {
              setModal(true);
              captureGAEvents(GAEvents.share, { event: 'promote', screen: 'promote' });
            }}
          >
            Share
          </Button>
        </div>
      </Container>
      <ShareModal
        open={openModal}
        onClose={() => setModal(false)}
        url={`www.fainlearn.com/teacher/promote/${currentUser.id}`}
      />
    </Page>
  );
}
